// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-module--title--2IDyF","description":"styles-module--description--3Fgvi","iconWrapper":"styles-module--iconWrapper--JSkRl"};